export default __webpack_public_path__ + "media/zurb/img/legacy/icons/press/cbs-f17239f688e5719e9425a4ca6c413b4e.png";